import classNames from "classnames";
import { InvestPoolStatus } from "../../types";
import { getInvestPoolStatusIndicatorColor } from "../../utils/coimex-utils";

interface IProps {
  status: InvestPoolStatus;
}

export default function InvestPoolStatusIndicator({ status }: IProps) {
  const color = getInvestPoolStatusIndicatorColor(status);
  return (
    <div className="flex items-center gap-1 text-xs">
      <span className="mr-1">Status</span>
      <span
        className={classNames("rounded-full", "w-2", "h-2", `bg-${color}`)}
      ></span>
      <span className={classNames(`text-${color}`)}>{status}</span>
    </div>
  );
}
